module.exports = __webpack_public_path__ + "img/product-preview-81.957047e.png";